// extracted by mini-css-extract-plugin
module.exports = {"CustomRandy":"CustomRandy_CustomRandy__2Siyy","ContentContainer":"CustomRandy_ContentContainer__2JWJi"};